<script>
import { plural } from '../../sci/utils'

export default {
    name: 'ConstructionMedia',
    props: {
        construction: {
            twoWay: true,
            type: Object,
            default: null
        },
        width: {
            type: String,
            default: '90px'
        }
    },
    computed: {
        photos () {
            return (this.construction && this.construction.photos) || []
        },
        highlightUrl () {
            const h = this.construction && this.construction.highlight
            if (!h) return null
            if (typeof h === 'string') return h
            return null
        },
        photosLabel () {
            return plural(this.photos.length, '%s foto', '%s fotos', 'nenhuma foto')
        },
        label () {
            return this.photosLabel
        }
    }
}
</script>

<template>
    <div>
        <div class="border-img"
             style="cursor: pointer; position: relative;"
             :style="{width: width, height: width}"
             v-if="photos.length < 1">
            <div class="anchor-parent background-cover"
                 style="margin: 3px; background-image: url('/assets/images/imagem-nao-disponivel-media.png');"></div>
        </div>
        <div v-if="photos.length > 0">
            <div v-if="highlightUrl">
                <img class="border-img" :src="highlightUrl" :width="width" :height="width">
            </div>
            <div v-if="!highlightUrl" class="border-img"
                 style="position: relative;"
                 :style="{width: width, height: width}">
                <div class="anchor-parent background-cover"
                     style="margin: 3px; background-image: url('/assets/images/imagem-nao-disponivel-media.png');"></div>
            </div>
            <span class="galinfo" v-tooltip :vtitle="label">
                <i class="fa fa-camera"></i>
                {{ photos.length }}
            </span>
        </div>
    </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// ConstructionMedia.vue?58ac92f9